import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { selectChatIntentTypes } from '../../../accessors/index'
import IntentSelector from '../../../components/ReusableComponents/Messaging/IntentSelector/index'
import styles from './ChatTitle.module.scss'
import { ReactComponent as CloseIcon } from './close.svg'

const ChatTitle = ({ intentId, handleChangeIntent }) => {
  const [isSelectorVisible, setSelectorVisible] = useState()
  const [selectorPos, setSelectorPos] = useState()

  const intentTypes = useSelector(selectChatIntentTypes)

  function handleClickCategorize(e) {
    const { left: x, top: y } = e.target.getBoundingClientRect()

    setSelectorVisible(true)
    setSelectorPos({ x: x - 10, y: y + 10 })
  }

  function handleSeletIntent(intentId) {
    handleChangeIntent(intentId)
    setSelectorVisible(false)
  }

  return (
    <div className={styles.chatTitle}>
      <ul className={styles.todoList}>
        <li>Categorize important messages by hovering over them</li>
        <li>Read the whole conversation and categorize it</li>
      </ul>
      <button
        onClick={handleClickCategorize}
        className={intentId ? styles.categorizeDropdown : styles.categorizeButton}
      >
        {intentId ? intentTypes[intentId].name : 'Categorize conversation'}
      </button>
      <Link to="/aiTraining" className={styles.closeLink}>
        <CloseIcon />
      </Link>
      {isSelectorVisible && (
        <IntentSelector
          {...selectorPos}
          handleSelect={handleSeletIntent}
          handleClose={() => setSelectorVisible(false)}
          title={intentId ? 'Change category' : 'Categorize conversation'}
        />
      )}
    </div>
  )
}

export default ChatTitle
